module.exports = __webpack_public_path__ + "static/img/anzuo.8da58f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/anzuo.png
// module id = YHj1
// module chunks = 12